import {
  APP_PRIMARY_THEME_COLOR,
  BLACK_TEXT,
  BRIGHT_GREY,
  BROWN_HEADING,
  DIM_GREY,
  ECLIPSE,
  GREY91,
  GREY97,
  WHITE,
} from "../../consts/colors";

export const styles = {
  container: {
    backgroundColor: GREY97,
    padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
  },
  heading: {
    color: ECLIPSE,
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "32px",
    marginBottom: "8px",
  },
  description: {
    fontSize: "14px",
    color: BROWN_HEADING,
    marginBottom: "24px",
    lineHeight: "22px",
  },
  select: {
    width: "100%",
    backgroundColor: GREY97,
    border: `1px solid ${BRIGHT_GREY}`,
    borderRadius: "4px",
    marginBottom: "24px",
    "& .MuiSelect-select": {
      padding: "12px 16px",
      display: "flex",
      alignItems: "center",
    },
    "& fieldset": {
      border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: `1px solid ${APP_PRIMARY_THEME_COLOR}`,
    },
  },
  placeholder: {
    color: DIM_GREY,
    fontSize: "14px",
  },
  selectedValue: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  selectedLabel: {
    color: BLACK_TEXT,
    fontWeight: 500,
    fontSize: "14px",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "14px",
    color: DIM_GREY,
    "&:hover": {
      background: GREY91,
    },
    "&.Mui-selected": {
      backgroundColor: `${APP_PRIMARY_THEME_COLOR} !important`,
      color: WHITE,
    },
  },
  flag: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  saveButton: {
    width: "100%",
    height: "44px",
    backgroundColor: APP_PRIMARY_THEME_COLOR,
    color: WHITE,
    fontWeight: 700,
    fontSize: "16px",
    textTransform: "none",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: APP_PRIMARY_THEME_COLOR,
    },
  },
};
